<template>
  <div class = "wjTrainList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addTrain')}}</el-button>
      <el-table
        :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="title"
          label="标题">
        </el-table-column>
        <el-table-column prop="logo" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.logo == 1">技能</span>
            <span v-if="scope.row.logo == 2">安全</span>
            <span v-if="scope.row.logo == 3">流程</span>
            <span v-if="scope.row.logo == 4">作业</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('lang.lbl_wj_trainDate')"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.createTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:wjTrainList
 *@Description:万洁技能培训
 *@author:杜斌
 *@Copyright:格众科技
 *@date:2020-02-19
 */
// import { mapGetters } from 'vuex'

export default {
  name: '/manage/main.wjTrainList',
  data() {
    return {
      multipleSelection: [], // 多选框
      gardenId: this.$store.getters.gardenId, // 小区绑定值
      tableData: [], // 新闻list
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('wjTrainform', '')
    }, 200)
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    // 公司新闻-获取列表数据
    getData() {
      let loading = this.$loading()
      this.$get(`/wjTrain?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        }, 
        error => {
          loading.close()
          this.$message.error(error)
        })
    },
    // 新增培训
    add() {
      window.localStorage.setItem('wjTrainform', '')
      this.$router.push({ name: 'wjTrainEdit', query: { flag: false } })
    },
    // 编辑培训
    edit(rowData) {
      window.localStorage.setItem('wjTrainform', '')
      this.$router.push({ name: 'wjTrainEdit',
      query: {
        flag: true,
        object: rowData }
        })
    },
    // 删除培训
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
          this.$delete(`/wjTrain/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
</style>